import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import AppWrapper from './AppWrapper';
import { Provider } from 'react-redux';
import reportWebVitals from './reportWebVitals';
import store from './store/index';

// localStorage.setItem('Bearer', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjYzYTJjYjg5NWYyNDFiOThhNWI2NjY2OSIsImlhdCI6MTY3MTYyMjQzMSwiZXhwIjoxNjgwMjYyNDMxfQ.1AWin2FbLXrlCujAQjY9QAgefeO0t-RfuiLcct9CQ4g')
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    // <React.StrictMode>
    <Provider store={store}>
        <BrowserRouter
        // basename="/potreact"
        >
            <AppWrapper></AppWrapper>
        </BrowserRouter>
    </Provider>
    // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
